import React from "react";
import DashboardViewDropdown from "./DashboardViewDropdown";
import styles from "./styles.module.css";
import { useCurrentWatchlist, useIsLoading } from "~context/WatchlistContext";
import SummaryOverview from "~components/Watchlist/delta/SummaryOverview";

/**
 * Watchlist Overview Component (Delta)
 *
 * Displays market value summary from WatchlistContext using Octagon data directly
 */
export default function WatchlistOverview() {
  const currentWatchlist = useCurrentWatchlist();
  const isLoading = useIsLoading();

  return (
    <div className={styles.watchlistDashboardV2}>
      <div className={styles.overview}>
        <SummaryOverview
          marketValue={currentWatchlist?.marketValue}
          currency={currentWatchlist?.currency}
          isLoading={isLoading}
        />
        <DashboardViewDropdown />
      </div>
      <div className={styles.horizontalLine} role="separator" />
    </div>
  );
}
